/**
 * Beinhaltet die v3s-connection Elemente
 * @class directive_v3sConnections
 * @memberOf v3sWbtPlayerApp:exercise:connectable
 * @example
 * <v3s-connections>
 *      <v3s-connection v3s-from="cn01" v3s-to="cn02"></v3s-connection>
 * <v3s-connections>
 */
angular.module('v3sWbtPlayerApp').directive('v3sConnections', ['$compile', 'v3sExerciseService', function ($compile, v3sExerciseService) {
    return {
        restrict: 'E',
        require : ['^v3sExercise', 'v3sConnections'],
        controller : ['$scope', '$element', function($scope, $element){
            var self = this;

            //Alle Verbindungen
            self.connections = [];

            self.loadSavedConnections = function () {
                var savedConnections = v3sExerciseService.getExerciseData(this);
                return savedConnections;
            }

            /*
             * Fügt eine Verbindung dem connections-array hinzu
             * @param {object} conn - die Verbindung die hinzugefügt werden soll
             */
            self.addConnectionElement = function (conn) {
                self.connections.push(conn);
            }

            /**
             * Prüft, ob bereits eine Verbindung zwischen den beiden angegeben Elemente besteht und gibt diese ggf zurück
             * @param {string} from - id des ersten Elements
             * @param {string} to - id des zweiten Elements
             * @returns {object} foundConn - das gefunden v3sConnectionElement oder null
             */
            self.findConnection = function (from, to) {
                var foundConn = null;
                var foundExisting = false
                angular.forEach(self.connections, function (c) {
                    if ((c.to === to && c.from === from) || (c.to === from && c.from === to)) {
                        foundConn = c;
                    }
                });
                return foundConn;
            }

            /**
             * Sucht eine vorhanden Verbindung, setzt deren Wert auf "isDrawn" und gibt die zurück
             * @param {string} from - id des ersten Elements
             * @param {string} to - id des zweiten Elements
             * @returns {object} conn - die veränderte Connection
             */
            self.drawConnection = function (from, to) {
                var conn = self.findConnection(from, to);
                if (!!conn) {
                    conn.setUserAnswer(true);
                }
                return conn;
            }
            //Gibt die das connections Element zurück
            self.getConnections = function () {
                return self.connections;
            }
            self.createConnectionElement = function(id, from, to, x, y, deg, w) {
                var newConn = angular.element('<v3s-connection id="'+id+'" v3s-angle="'+deg+'" v3s-width="'+ w +'" v3s-left="'+ x +'" v3s-top="' + y + '" v3s-from="'+ from +'" v3s-to="'+ to +'" v3s-state="useradded"></v3s-connection>');
                $element.prepend(newConn);
                $compile(newConn)($scope);
            }
        }],
        link: function (scope, element, attrs, ctrls) {

            var v3sExerciseCtrl = ctrls[0];
            var v3sConnectionsCtrl = ctrls[1];

            v3sExerciseCtrl.exercise.createConnection = function (id, from, to, x, y, deg, w, state) {
                var updatedConn = v3sConnectionsCtrl.drawConnection(from, to);
                if (!!updatedConn) {
                    updatedConn.element.attr({
                        "v3s-from": from,
                        "v3s-to" : to,
                        "v3s-top": y,
                        "v3s-left": x,
                        "v3s-angle": deg+ '_short',
                        "v3s-width": w,
                        "v3s-state" : state
                    });
                    $compile(updatedConn.element)(scope);
                } else {
                    v3sConnectionsCtrl.createConnectionElement(id, from, to, x, y, deg, w);
                }

            }
            var savedConnections = v3sConnectionsCtrl.loadSavedConnections();
            angular.forEach(savedConnections, function(conn,key){
                if (conn.isDrawn) {
                    v3sExerciseCtrl.exercise.createConnection(key, conn.userAnswer.from, conn.userAnswer.to, conn.element.attr('v3s-left'), conn.element.attr('v3s-top'), conn.element.attr('v3s-angle'), conn.element.attr('v3s-width'), "loaded");
                }
            });
        }
    }
}]);
